<template>
    <Sidebar />
    <Content class="reports-content">
        <header class="creator-header">
            <h2>Reports</h2>
        </header>
        <Loading class="static" v-if="is_loading" />
        <div class="data-wrap" v-else>
            <Scrollbar :class="['data-list']" :show_bar="true">
                <Table :style="'--top: 0px'">
                    <template #head>
                        <tr>
                            <th class="name-row"><span>Report Name</span></th>
                            <th><span>Description</span></th>
                            <th class="date-row"><span>Date Range</span></th>
                            <th class="svg-th"><span>Action</span></th>
                        </tr>
                    </template>

                    <template #body>
                        <!-- template pic -->
                        <template v-if="data.length === 0">
                            <tr>
                                <td colspan="4">
                                    <NoData />
                                </td>
                            </tr>
                        </template>

                        <tr v-else v-for="(row, index) in data" :key="index" v-show="row.show">
                            <td class="name-row"><span>{{ row.name }}</span></td>

                            <td><span>{{ row.desc }}</span></td>

                            <td class="date-row">
                                <DatePicker @update-date="updateDate" :spec_key="index" />
                            </td>

                            <td>
                                <span class="svg-td">
                                    <svg-icon :class="[!row.canDownload&& 'not-allowed-svg']" name="download" @click="fileDownload(row)" />
                                    <!-- <svg-icon name="email" /> -->
                                </span>
                            </td>
                        </tr>
                    </template>

                </Table>
            </Scrollbar>
        </div>
    </Content>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';
import Loading from '@/components/ui/Loading.vue';
import Button from '@/components/ui/Button.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Table from '@/components/ui/Table.vue';
import NoData from '@/components/creator/NoData.vue';
import DatePicker from '@/components/ui/DatePicker.vue';
import moment from 'moment';
import { handleMaxMinFun } from '@/utils/SwitchFun';

export default {
    name: 'Reports',

    components: {
        Sidebar,
        Scrollbar,
        Loading,
        Content,
        Button,
        Table,
        NoData,
        DatePicker,
    },

    data() {
        return {
            is_loading: false,
            data: [
                {
                    name: 'Creator Performance By Day',
                    desc: 'Track daily sales and engagement metrics for each creator',
                    start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
                    end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
                    id: 1,
                    show:true,
                    canDownload: false
                },
                {
                    name: 'Product Performance',
                    desc: 'Analyze engagement trends for products that creators share',
                    start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
                    end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
                    id: 2,
                    show:true,
                    canDownload: false
                },
                {
                    name: 'Shortlink Performance',
                    desc: '',
                    start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
                    end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
                    id: 3,
                    show:false,
                    canDownload: false
                },
                {
                    name: 'Collections Performance',
                    desc: 'Measure sales and engagement across curated product collections',
                    start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
                    end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
                    id: 4,
                    show:true,
                    canDownload: false
                },
                {
                    name: 'Storefront Posts Performance',
                    desc: '',
                    start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
                    end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
                    id: 5,
                    show:false,
                    canDownload: false
                },
                {
                    name: 'Creator Motom Activity',
                    desc: `View sales information by storefront creators' Motom activity`,
                    start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
                    end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
                    id: 6,
                    show: false,
                    canDownload: true
                }
            ],
            start_date: moment().add(-30, 'days').format('YYYY-MM-DD'),
            end_date: moment().add(-1, 'days').format('YYYY-MM-DD'),
        }
    },

    computed: {
        permission_reports(){
            return this.$store.state.user_data?.permission_list?.reports;
        },
    },

    methods: {
        updateDate(obj) {
            this.data[obj.key].start_date = moment(obj.start_date).format('YYYY-MM-DD');
            this.data[obj.key].end_date = moment(obj.end_date).format('YYYY-MM-DD');
        },

        fileDownload(row) {
            this.$store.state.is_loading = true;


            let params_data = {
                start_date: row.start_date,
                end_date: row.end_date,
            };

            let api = '/creator/get-performance-by-creator-by-day-csv-file';
            switch (row.id) {
                case 1:
                    api = '/creator/get-performance-by-creator-by-day-csv-file';//done
                    break;
                case 2:
                    api = '/creator/get-product-performance-csv-file';//done
                    break;
                case 3:
                    api = '/creator/get-performance-by-creator-by-day-csv-file';
                    break;
                case 4:
                    api = '/creator/get-collections-performance-csv-file';//done
                    break;
                case 5:
                    api = '/creator/get-performance-by-creator-by-day-csv-file';
                    break;
                case 6:
                    api = '/creator/get-motom-sales-by-creator-by-day-csv-file';//done
                    break;
            }


            this.$ajax(api, {
                params: params_data,
                method: 'get',
            }).then(res => {
                if (res.status == 200) {
                    let name = res.headers['content-disposition'].split('filename=');
                    name = name[1] ? name[1] : 'report';
                    this.$JsDownload(res.data, `${name}.csv`);
                    this.$store.state.is_loading = false;
                    this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Download Success!`);
                } else {
                    this.$store.state.is_loading = false;
                    this.$notify(`<svg><use xlink:href="#yes--sprite"></use></svg> Download False!`);
                }
            });
        },

        startFunction() {
            if (this.$store.state.user_data.merchant_account_id) {
                if(!this.permission_reports?.downloadReports?.permission){
                    this.$router.push({ name: 'creator--list' });
                };
                this.data.forEach(e=>{
                    let checkTime = handleMaxMinFun(e.start_date, e.end_date, this);
                    e.start_date = checkTime[0];
                    e.end_date = checkTime[1];

                    if(this.$store.state.user_data.merchant_account.merchant_name_in_program == 'macys' && e.id == 6){
                        e.show = true;
                    }

                });


                if(this.permission_reports.downloadCreatorPerformanceByDay.permission){
                    this.data[0].canDownload = true;
                }

                if(this.permission_reports.downloadPerformanceOverview.permission){

                };

                if(this.permission_reports.downloadProductPerformance.permission){
                    this.data[1].canDownload = true;
                }

                if(this.permission_reports.downloadCollectionsPerformance.permission){
                    this.data[3].canDownload = true;
                }

                if(this.permission_reports.downloadPostPerformance.permission){
                    this.data[4].canDownload = true;
                }

                if(this.permission_reports.downloadBrandContentPerformance.permission){
                  
                };
            }
        },

    },
    mounted() {
        this.startFunction()
    }
}
</script>

<style lang="scss">
.reports-content {
    padding: 24px 48px;

    header {
        display: flex;
        align-items: center;

        h2 {
            font: var(--font-demi-36);
            color: var(--Black-100);
            flex: 1;
        }
    }

    .data-wrap {
        margin: 16px 0;
        border-top: 1px solid var(--black-20);
        height: calc(95% - 16px);

        .btn {
            border: solid 1px var(--border);
            font-size: 12px;
            padding: 6px 8px;
            border-radius: 6px;
            text-align: center;
        }

        .svg-th {
            width: 100px;
        }

        .svg-td {
            display: flex;
            gap: 12px;
            align-items: center;
            justify-content: flex-start;

            .svg-icon {
                width: 14px;
                height: 14px;
                cursor: pointer;
            }
        }

        .date-row {
            width: 350px;
        }

        .name-row {
            width: 300px;
        }

        .not-allowed-svg{
            pointer-events: none;
            cursor: not-allowed;
            opacity: 0.5;
        }
    }
}
</style>